export default __webpack_public_path__ + "static/media/vigevano.9447ef19.png";